import { Box, Typography } from '@material-ui/core';
import React from 'react';
import { FBForm, FBTextEditor, FBTextField } from '..';
import { translate } from '../../../common/intl';
import { store } from '../../../state/store';
import { Autocomplete } from '../../components/forms/fields-next';
import Text from '../../components/Text';
import { TransitionIdent } from '../../components/transitionDialog/types';
import { useStyle } from './FBApprovalPasswordForm.styles';
import { FBApprovalPasswordFormProps } from './FBApprovalPasswordForm.types';
import { withFBApprovalPasswordForm } from './FBApprovalPasswordForm.wrap';

const FBApprovalPasswordForm: React.FunctionComponent<FBApprovalPasswordFormProps> = ({
  formState,
  isApproverVisible = false,
  isPasswordVisible = false,
  children,
  transition,
}) => {
  // Prevent form submitting.
  const submitHandler: React.FormEventHandler = React.useCallback(
    (event) => event.preventDefault(),
    [],
  );
  const classes = useStyle();
  const { name } = store.getState().auth.user;

  return (
    <FBForm {...{ formState }}>
      {/* Isolate autocomplete triggering in current form */}
      <form autoComplete="off" onSubmit={submitHandler}>
        {!isApproverVisible && <Box className={classes.labelContainer}>
          <Typography className={classes.label}>
            <Text translation="document.action.approvers" />
          </Typography>
          <Autocomplete
            disabled
            value={{ label: name, value: name }}
            getOptionLabel={(option) => option.label}
          />
        </Box>}
        {(transition !== TransitionIdent.REJECT || isPasswordVisible) && <FBTextField
          rules="required"
          name="password"
          inputProps={{
            type: 'password',
            placeholder: translate('document.action.password.placeholder'),
          }}
          label="form.builder.password"
        /> }
        {[TransitionIdent.REJECT, TransitionIdent.REJECT_WITH_PASSWORD].includes(transition as TransitionIdent)
        && <FBTextEditor
          name="comment"
          label="transition.action.rejection.comment"
          placeholder={translate('transition.action.rejection.comment.placeholder')}
          disabled={false}
        /> }
        <Box display="flex" justifyContent="center" mx={0}>
          {children}
        </Box>
      </form>
    </FBForm>
  );
};

export default withFBApprovalPasswordForm(FBApprovalPasswordForm);
